import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/canadian-maple-leaf': {
    width: 465,
    height: 512,
    paths: [
      {
        d: 'M232.9 0S195.4 72.3 190.4 79.8C185.4 89.8 180.4 89.8 172.8 84.8 162.8 79.8 132.7 62.4 132.7 62.4S160.3 182 160.3 192C162.8 202 152.8 209.5 142.7 202 140.2 199.5 87.6 139.7 87.6 139.7S75.1 167 72.6 172C70.1 177 67.6 181.9 60.1 179.5 50 177 2.4 167 2.4 167S20 226.7 22.5 234.3C24.9 240.3 27.5 246.8 17.5 251.7L0 259.3S102.6 349.2 105.2 351.7C110.3 356.7 115.2 359.2 110.3 374.2 105.2 389.2 100.2 409.3 100.2 409.3S195.4 389.2 205.5 386.7C214.2 385.8 223.8 389.2 223.8 399.2 223.8 409.3 218 512 218 512H248S242.2 409.3 242.2 399.2C242.2 389.2 251.7 385.8 260.6 386.7 270.6 389.2 365.8 409.3 365.8 409.3S360.8 389.2 355.8 374.2 355.8 356.7 360.8 351.7C363.3 349.2 466 259.3 466 259.3L448.5 251.8C438.5 246.9 441.1 240.3 443.5 234.4 445.9 226.8 463.6 167.1 463.6 167.1S415.9 177.1 405.9 179.6C398.4 182 395.9 177.1 393.4 172.1S378.4 139.7 378.4 139.7 325.8 199.6 323.3 202C313.3 209.5 303.2 202 305.7 192 305.7 182 333.3 62.4 333.3 62.4S303.2 79.8 293.2 84.8C285.7 89.8 280.6 89.8 275.6 79.8 270.5 72.3 232.9 0 232.9 0'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/canadian-maple-leaf.js
// module id = GXLm
// module chunks = 144